

	var MoeFileItem = function()
	{
		this._id = "";
		this._settings = {};
		this._fileId = 0;
		this._name = "";
		this._size = "";
		this._viewUrl = "";
		this._progress = 0;

	};

    MoeFileItem.prototype =
		{
			initialize: function(id, settings)
			{
				this._id = id;
				this._settings = settings ? settings : {};


				this._fileId = parseInt(this.getSetting("fileId", 0));
				this._name = this.getSetting("name", "");
				this._size = this.getSetting("size", "");
				this._viewUrl = this.getSetting("viewUrl", "");
                this.setProgress(this.getSetting("progress", 0));
                this.state = 'file-loading';
			},
			getId: function()
			{
				return this._id;
			},
			getSetting: function(name, defaultval)
			{
				return typeof(this._settings[name]) != "undefined" ? this._settings[name] : defaultval;
			},
			getFileId: function()
			{
				return this._fileId;
			},
			setFileId: function(fileId)
			{
				this._fileId = fileId;
			},
			getName: function()
			{
				return this._name;
			},
			getSize: function()
			{
				return this._size;
			},
			getProgress: function()
			{
				return this._progress;
            },
            
            getProgresStyle: function()
			{
                let style = {
                            width: this._progress+'%',
                            display: this._progress < 100 ? "" : "none",
                };

               
                return style;
				
            },
            
			setProgress: function(progress)
			{
                progress = parseInt(progress);
                
              
                
				if (isNaN(progress) || progress < 0)
				{
					progress = 0;
				}

				if (progress > 100)
				{
					progress = 100;
				}

				if (this._progress === progress)
				{
					return;
				}

                this._progress = progress;
                /*
				if (this._hasLayout)
				{
					this._progressBar.style.width = this._progress + "%";
					this._progressText.innerHTML = this._progress + "%";
					this._progressWrap.style.display = progress < 100 ? "" : "none";
                }
                */
			},
		
            
            getState: function(){
                return this.state;
            },
            
            
            setLoaded: function(url){
                this.state ='';
                this._viewUrl = url;
            },

            getViewUrl: function(){
                return this._viewUrl;
            }
		
		};

	MoeFileItem.create = function(id, settings)
	{
		var self = new MoeFileItem();
		self.initialize(id, settings);
		return self;
	};

export {MoeFileItem}


// WEBPACK FOOTER //
// ./src/core/fileitem.js